document.addEventListener('alpine:init', () => {

    Alpine.data('carConfig', () => ({
        loading: false,
        buttonLabel: 'Devis gratuit',
        message: '',
        waranty: {
            reference: '',
            desc: '',
            price: 0
        },
        prestations: [],
        userdetails: {
            civilite : 'M',
            nom : '',
            prenom : '',
            raisonsociale : '',
            email : '',
            telephone : '',
            cp : '',
        },
        reprise: false,
        setWaranty (e) {
            if (e.target.getAttribute('data-price') != this.waranty.price ) {
                this.waranty.desc = e.target.getAttribute('data-desc');
                this.waranty.price = e.target.getAttribute('data-price');
                this.$store.selectedWaranty = this.waranty;
            } else {
                this.$store.selectedWaranty = {};
                this.waranty = {};
            }
        },
        setPrestation(e) {
            let reference = e.target.getAttribute('data-reference');
            if (!this.prestations.find(selectedPrestation => selectedPrestation.reference === reference)){
                this.prestations.push(
                    {
                        'reference' : e.target.getAttribute('data-reference'), 
                        'prestation' : e.target.getAttribute('data-prestation'), 
                        'price' : e.target.getAttribute('data-price')
                    }
                );
            } else {
                let index = this.prestations.findIndex(selectedPrestation => selectedPrestation.reference === reference);
                this.prestations.splice(index, 1);
            }
            this.$store.prestations = this.prestations;
        },
        getTotalAmount() {
            let totalAmount = parseInt(this.$store.car.price);
            totalAmount+=parseInt(this.$store.fraisdossier);
            totalAmount+=parseInt(this.$store.atHome.price);
            totalAmount+=parseInt(this.$store.car.malus);
            this.$store.prestations.forEach( presta => {
                totalAmount += parseInt(presta.price);
            });
            // return totalAmount;
            return new Intl.NumberFormat('fr-FR').format(
                totalAmount,
              )
        },
        delOpt(type, index) {
            switch(type) {
                case 'waranty':  
                    this.waranty = {};
                    break;
                case 'insurance' : 
                    this.$store.currentInsurancesTotal -= parseFloat(this.$store.selectedInsurance[index].insuranceMonthlyAmount);
                    this.$store.selectedInsurance.splice(index, 1);
                    break;
                case 'extension':
                    this.$store.selectedExtension = {};
                    break;
            }
        },
        checkConfigAndModal() {
            this.buttonLabel = 'Création du devis...'
            this.loading = true;
            
            this.message = '';
            
            Fancybox.show([{ src: "#devis_form", type: "inline" }]);

            this.buttonLabel = "Devis gratuit";
            this.loading = false;
        },

        sendQuotation() {
            this.loading = true;
            let currentCp = this.$store.selectedCity ? this.$store.selectedCity.zipcode : '';
            let dpt = currentCp ? currentCp.substr(0, 2) : '';
            let selectedInsurance = (this.$store.selectedInsurance).map(insurance => JSON.parse(insurance));

            let optionsConfigurable = (this.$store.optionsConfigurable.list).length > 0 ? this.$store.optionsConfigurable.list : null;
            let colorConfigurable = this.$store.optionsConfigurable && this.$store.optionsConfigurable.couleur ? this.$store.optionsConfigurable.couleur : null;
            let isConfigurable = (this.$store.optionsConfigurable.list).length > 0 || this.$store.optionsConfigurable.couleur ? 1 : 0;

            let formData = {
                delivery : this.$store.pdv,
                prestations : this.$store.prestations,
                home: this.$store.atHome,
                car: this.$store.car.id,
                user : this.userdetails,
                funding: this.$store.selectedFinancial,
                insurance: selectedInsurance,
                extension: this.$store.selectedExtension,
                waranty : this.$store.selectedWaranty,
                department: dpt,
                optionsConfigurable: optionsConfigurable,
                isConfigurable: isConfigurable,
                colorConfigurable: colorConfigurable
            };


            // redirection vers le controller
            fetch('/webauto/sendQuotation', {
                method: 'POST',
                headers: { 
                    'Content-Type': 'application/json',
                    'X-CSRF-TOKEN': document.head.querySelector('meta[name=csrf-token]').content
                    // 'g-recaptcha-response': document.querySelector('input[name="g-recaptcha-response"]').value
                },
                body: JSON.stringify(formData)
            })
            .then(r => r.json())
            .then(json => {
                Fancybox.close();

                if(json.status && json.status == 'error') {
                    Fancybox.show([{ src: '<div class="message"><h2>Devis immédiat</h2><p>'+json.message+'</p></div>', type: "html" }]);
                    setTimeout(function(){ 
                        Fancybox.close();
                    }, 2000);
                    return;
                } else {
                    pushLeadEvent('generate_lead', 'lead', this.userdetails);
                    if(this.reprise) {
                        Fancybox.show([{ src: '<div class="message"><h2>Devis immédiat</h2><p>Votre demande a bien été enregistrée !</p><p>Un conseiller Degrifcars.com reviendra vers vous dans les meilleurs délais. <br>Vous pouvez maintenant simuler la reprise de votre véhicule actuel</p></div>', type: "html" }]);
                        setTimeout(function(){ 
                            Fancybox.close();
                            window.location.href = "/estimation";
                        }, 4500);
                    } else {
                        Fancybox.show([{ src: '<div class="message"><h2>Devis immédiat</h2><p>Votre demande a bien été enregistrée !</p><p>Un conseiller Degrifcars.com reviendra vers vous dans les meilleurs délais.</p></div>', type: "html" }]);
                        setTimeout(function(){ 
                            Fancybox.close();
                        }, 2000);
                    }
                }
            })
            .catch((e) => {
                console.log(e);
                this.loading = false;
            })
            .finally(() => {
                this.loading = false;
                this.buttonLabel = 'Devis gratuit'
            })
        }
    }));

    Alpine.data('financement', () => ({
        md5 : true,
        price: 0,
        scale: {},
        apport: 2000,
        duree: 24,
        km: 20000,
        loyerStart: 0,
        loyerRelax:0,
        loastart: {
            apport: 0,
            duree: 24,
            km: 20000,
            price: 0,
            mentions: '',
        },
        loarelax: {
            apport: 0,
            duree: 24,
            km: 20000,
            price: 0,
            mentions: '',
        },
        mec: '2022-01-01',
        apartirde: '-',
        mentions: '',
        insurances: [],
        prixCg: 0,
        ecotaxe: 0,
        cv: 0,
        max_km: 30000,
        max_loyer: 80,
        destination: 'VN',
        valeur_rachat: 0,
        initloas() {
            this.loastart.price = this.loyerStart;
            this.loarelax.price = this.loyerRelax;
            this.loastart.km = this.km;
            this.loarelax.km = this.km;
            this.loastart.apport = this.apport;
            this.loarelax.apport = this.apport;
            this.loastart.duree = this.apport > 0 || this.destination == "VU" ? this.duree : this.duree - 1;
            this.loarelax.duree = this.apport > 0 ? this.duree : this.duree - 1;

            this.calculation('loastart');
            if(this.destination != "VU") {
                this.calculation('loarelax');
                setTimeout(() => {
                    this.setType('loarelax');
                }, 100);
            }
            

        },
        // simul() {
        //     let formData = {
        //         type : this.$store.type,
        //         md5: this.md5
        //     };

        //     this.insurances = [];
        //     this.$store.selectedInsurance = [];
        //     this.$store.selectedExtension = {};
        //     this.resetFinancialDatas()
        //     if (this.$store.type == '') {
        //         return;
        //     }
        //     this.calculation();
        // },
        resetFinancialDatas() {
            this.$store.selectedFinancial.type = this.$store.type;
            this.$store.selectedFinancial.apport = this.$store.type ? this.apport : '';
            this.$store.selectedFinancial.duree = this.$store.type ? this.duree : '';
            this.$store.selectedFinancial.km = this.$store.type=='leasing' ? this.km : '';
            this.$store.selectedFinancial.apartirde = '';
        },
        calculation(forced = null) {
            let loatype = forced ? forced : this.$store.type;
            let formData = {
                loatype: loatype,
                loastart: this.loastart,
                loarelax: this.loarelax,
                scaleId : this.scale.id,
                purchaseAmount: parseInt(this.price),
                optionsConfigurable: this.$store.optionsConfigurable.totalOptions,
                carRef: this.$store.car.id,
                md5: this.md5,
                mec: this.mec,
                carName: this.$store.car.name,
                insuranceMonthlyAmount: 0,
                insuranceTotalAmount: 0,
                creditAmountMin: this.scale.creditAmountMin,
                creditAmountMax: this.scale.creditAmountMax ?? 0,
                numberOfPaymentsMin: this.scale.numberOfPaymentsMin ?? 0,
                numberOfPaymentsMax: this.scale.numberOfPaymentsMax ?? 0,
                max_km: this.max_km,
                max_loyer: this.max_loyer,
                destination: this.destination,
            };

            this.resetFinancialDatas();
            this.mentions = '';
            // reset assurances
            // if (this.$store.type != '' ) {
            //     this.insurance();
            // }

            this.$store.calculating = true;
            // redirection vers le controller
            fetch('/webauto/calculation', {
                method: 'POST',
                headers: { 
                    'Content-Type': 'application/json',
                    'X-CSRF-TOKEN': document.head.querySelector('meta[name=csrf-token]').content
                },
                body: JSON.stringify(formData)
            })
            .then(r => r.json())
            .then(json => {
                this[loatype] = json[loatype];
                this.apartirde = json[loatype].price;
                this.mentions = json[loatype].mentions;
                this.$store.apartirde = this.apartirde;
                this.$store.selectedFinancial.type = loatype;
                this.$store.selectedFinancial.apport = json[loatype].apport;
                this.$store.selectedFinancial.duree = json[loatype].duree;
                this.$store.selectedFinancial.km = json[loatype].km;
                this.$store.selectedFinancial.apartirde = this.$store.apartirde.toString();
                this.valeur_rachat = json['valeur_rachat'];
                if(json['km_max'])
                {
                    $('#'+loatype+'_km').attr('max', parseInt(json['km_max']));
                }
                if(json['duree_max'])
                {
                    $('#'+loatype+'_duree').attr('max', parseInt(json['duree_max']));
                }
            })
            .catch(() => {
                console.log("catch calculation")
            })
            .finally(() => {
                this.$store.calculating = false;
            })
        },
        
        setInsurance(id, insurance, price) {
            if (!this.$store.selectedInsurance.find(selectedInsurance => selectedInsurance.id === id)){
                this.$store.selectedInsurance.push({id: id, type: insurance, price: price});
                // this.$store.currentInsurancesTotal += parseFloat(insurance.insuranceMonthlyAmount);
            } else {
                let index = this.$store.selectedInsurance.findIndex(selectedInsurance => selectedInsurance.id === id);
                this.$store.selectedInsurance.splice(index, 1);
            }
        },
        setExtension(insurance) {
            this.$store.selectedExtension = insurance;
        },
        setType(type) {
            this.$store.type = type;
            if (type !== undefined && type != '') {
                this.$store.apartirde = this[type].price;
                this.$store.selectedFinancial.type = type;
                this.$store.selectedFinancial.apport = this[type].apport;
                this.$store.selectedFinancial.duree = this[type].duree;
                this.$store.selectedFinancial.km = this[type].km;
                this.$store.selectedFinancial.apartirde = this.$store.apartirde.toString();
            } else {
                this.resetFinancialDatas();
            }
        },
    }));

    
    Alpine.store('apartirde', 0);
    Alpine.store('currentInsurancesTotal', 0);
    Alpine.store('type', 'loa-relax');
    Alpine.store('calculating', false);
    Alpine.store('car', {});
    Alpine.store('dpt', false);
    Alpine.store('prestations', []);
    Alpine.store('selectedCity', {});
    Alpine.store('selectedWaranty', {});
    Alpine.store('selectedInsurance', []);
    // Alpine.store('optionsConfigurable', []);
    Alpine.store('optionsConfigurable', {
        list: [],
        couleur: '',
        totalOptions:0,

        updateConfigOptions() {
            setTimeout(() => {
                this.totalOptions = 0;
                let colorPrice = this.couleur ? this.couleur.split("#") : 0;
                this.totalOptions+=colorPrice ? parseFloat(colorPrice[1]) : 0;
                // this.$store.car.priceOptions = 0;
                (this.list).forEach((option, index) => {
                    let opt = option.split("#");
                    // calcul le montant des options ajoutées
                    this.totalOptions+=parseFloat(opt[1]);
                });
                $('#recalculateFinanco').click();
            }, 150);
        }
    });

    Alpine.store('selectedExtension', {});
    Alpine.store('selectedFinancial', {
        type: '',
        apport: '',
        duree: '',
        km: '',
        apartirde: '',
    });
    Alpine.store('pdv', {});
    // Alpine.store('atHome',  {
    //     type: '',
    //     price: 0,
    //     city: ''
    // });
    Alpine.store('atHome',  {
        type: '',
        price: 0,
        city: ''
    });
    Alpine.store('fraisdossier', 295);
})
